import styled from 'styled-components';
// import { rgba } from 'polished';

// CONSTANTS
import colors, { GRAY_SUIT, ATHENS_GRAY, WHITE, SANTAS_GRAY, MAIN_BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const SBillingDetails = styled.div`
  .billing-item-wrapper {
    display: flex;
  }

  .billing-item-wrapper + .billing-item-wrapper {
    margin-top: 24px;
  }

  .card-info-wrapper {
    &:first-of-type {
      margin-right: 34px;
    }
  }
`;

export const SSubscriptionPlanInfo = styled.div`
  .plan-info {
    position: relative;
    padding: 24px 15px 24px;
    background-color: ${ATHENS_GRAY};

    &__label {
      font-weight: 500;
      font-size: 1.8rem;
      line-height: 2rem;
    }

    &__label-2 {
      font-size: 1.8rem;
      line-height: 2rem;
    }
  }

  hr {
    margin: 12px 0;
  }

  .plan-title {
    font-size: 2.4rem;
    line-height: 2rem;
    font-weight: 400;
  }

  .main-info {
    display: flex;
    align-items: center;
    margin-bottom: -10px;
  }

  .img-wrapper {
    width: 158px;
    height: 119px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    padding: 10px;
    border-radius: 8px;
    background-color: ${WHITE};
    box-shadow: 0 4px 24px ${colors.appCard.hover.shadow};

    img {
      width: 100%;
      max-width: none;
      height: auto;
    }
  }

  .MuiDivider-root {
    background-color: ${GRAY_SUIT};
  }

  .billing-details {
    margin: 32px 0;
  }

  .addons {
    &__label {
      font-size: 1.4rem;
      line-height: 1.6rem;
      font-weight: 600;
    }
  }

  .total-price-wrapper {
    margin-top: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &--has-discount {
      align-items: flex-start;

      .total-price {
        text-align: right;
      }

      .discount {
        display: block;
      }
    }
  }

  .edit-plan {
    text-align: right;

    button {
      color: ${MAIN_BLACK};
    }
  }

  .desc-wrapper {
    &__item {
      &--tax,
      &--one-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      &--without-indent {
        margin-bottom: 0 !important;
      }

      &:not(:last-of-type) {
        padding-bottom: 14px;
        margin-bottom: 14px;
      }
    }

    &__info {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &--has-included,
      &--has-discount {
        align-items: flex-start;
      }
    }
  }

  .price {
    font-weight: 400;

    &--has-included,
    &--has-discount {
      text-align: right;

      > span:not(.price__price) {
        display: block;
      }

      .price {
        &__price {
          position: relative;

          &,
          span {
            color: ${SANTAS_GRAY};
          }

          &:before {
            content: '';
            position: absolute;
            right: -3px;
            left: -3px;
            top: 50%;
            transform: translate(0, -50%);
            height: 1px;
            background-color: ${SANTAS_GRAY};
          }
        }

        &__discount {
          font-weight: 400;
        }
      }
    }
  }

  .plan-footer {
    padding: 12px 0 9px;
    background-color: ${GRAY_SUIT};
    border-radius: 0 0 8px 8px;

    font-size: 1.2rem;
    line-height: 2.2rem;

    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      height: 14px;
      width: auto;
    }
  }

  ${breakpoints.up('md')} {
    border-radius: 8px;

    position: fixed;
    width: 350px;
    height: auto;
    max-height: calc(100vh - ${p => p.theme.headerHeight}px - 32px - 12px);
    overflow-y: auto;
    overflow-x: hidden;

    .plan-info {
      padding: 16px 16px 20px;

      .main-info {
        flex-direction: column;
        align-items: flex-start;
      }

      .img-wrapper {
        width: 318px;
        height: 120px;
        margin-right: 0;
        margin-bottom: 15px;

        img {
          height: 100%;
          max-height: 120px;
          width: auto;
        }
      }

      .plan-subscription {
        margin-top: 24px;
      }
    }
  }
`;

export const SpecialOffer = styled.label`
  margin-top: 20px;
  cursor: pointer;
  display: block;

  .special-offer {
    &__header {
      padding: 5px;
      background-color: ${p => p.theme.palette.primary.main};
      color: ${p => p.theme.palette.primary.contrastText};
      border-radius: 8px 8px 0 0;
    }

    &__content {
      padding: 10px 5px;
      display: flex;
      border: 1px solid ${SANTAS_GRAY};
      border-radius: 0 0 8px 8px;
      justify-content: center;
    }
  }
`;

export default SSubscriptionPlanInfo;
